import React, { FC, useContext, useRef } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESButton } from "@app/shared/qes-standards/Button";
import { JobBarChart } from "@app/performance/job-statistics/JobBarChart";
import { JobStastiticsContext } from "@app/performance/job-statistics/JobStatisticsContext";
import { resizeChartToFitLabels } from "@app/performance/job-statistics/resizeChart";
import { PreDefinedJobStatisticsChart, GraphTypeEnum } from "@app/performance/job-statistics/types";

interface PredefinedJobBarChartWrapperProps {
    chartModel: PreDefinedJobStatisticsChart;
}


export const PredefinedJobBarChartWrapper: FC<React.PropsWithChildren<PredefinedJobBarChartWrapperProps>> = (props: PredefinedJobBarChartWrapperProps) => {
    const context = useContext(JobStastiticsContext);
    const containerRef = useRef<HTMLSpanElement>(null);

    return (
        <span ref={containerRef}>
            <QESButton
                className="job-chart__refresh"
                qesType="secondary"
                qesTestId={`job-chart__refresh--${props.chartModel.jobType}--${props.chartModel.chartType}`}
                onClick={() => context.refreshPredefinedChart(props.chartModel.jobType, props.chartModel.chartType)}
            >
                <QesIcon iconName={QesIcons.RefreshCcwV2} description="Refresh chart" />
            </QESButton>
            <QESButton
                className="job-chart__resize"
                qesType="secondary"
                qesTestId={`job-chart__resize--${props.chartModel.jobType}--${props.chartModel.chartType}`}
                onClick={() => resizeChartToFitLabels(containerRef.current)}
            >
                <QesIcon iconName={QesIcons.ArrowsVertical} description="Resize chart" />
            </QESButton>
            <JobBarChart
                chartType={props.chartModel.chartType}
                dataPoints={props.chartModel.dataPoints}
                yAxisLabel={props.chartModel.chartType === GraphTypeEnum.Unknown ? "Job Count" : props.chartModel.chartType}
            />
        </span>
    )
}
